import React from 'react';
const SvgCaretRight: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.505 3l8.995 9.027L7.5 21"
      />
    </svg>
  );
};
export default SvgCaretRight;
